import React, { useEffect, useState } from "react";
import "../PaymentsDues/PaymentsDues.css";
import { IoEyeOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Dropdown from "react-bootstrap/Dropdown";
import "./Quotations.css";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import { axiosInstance } from "../../../axiosInstance";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";
import TablePagination from "@mui/material/TablePagination";

export const Quotations = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // table pagination
  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem("dis_quot_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("dis_quot_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [totalCount, setTotalCount] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // reset to first page
    sessionStorage.setItem("dis_quot_rowsPerPage", +event.target.value);
    sessionStorage.setItem("dis_quot_page", 0);
  };
  const [show, setShow] = useState(false);
  const [filterToggler, setFilterToggler] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [quotationData, setQuotationData] = useState({});

  function handleClearFilters() {
    setFilterToggler("");
    setSearchQuery("");
    setSelectedLabel("");
  }
  function handleReset() {
    setSearchQuery("");
  }
  async function fetchQuotationDetails() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: page + 1, // atleast 1 page
          page_size: rowsPerPage,
          search: searchQuery || "",
          date: selectedLabel || "",
          status: filterToggler || "",
        },
      };
      const response = await axiosInstance.get("quotation/list/", config);
      if (response.data.status === "success" || response.status === 200) {
        setQuotationData(response.data.data);
        setTotalCount(response.data?.data.count);
        console.log("quotation details fetched successfully!");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "failed to fetch quotation details",
      );
      console.log("failed to fetch quotation details");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchQuotationDetails();
  }, [page, rowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (page !== 0) {
        setPage(0);
      } else {
        fetchQuotationDetails();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery, selectedLabel, filterToggler]);

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="ordersContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div className="dasboardTitle">
              <div>Quotations</div>
              <div> Create and track quotations for retail customers.</div>
            </div>
            <div className="d-flex gap-2">
              <div className="inventoryBtnReorder">
                <button onClick={() => navigate("/state-newQuotations")}>
                  + New Quotation
                </button>
              </div>
            </div>
          </div>
          {/* cards section  */}
          <div className="quotationCardsGrid">
            <div className="inventoryCard">
              <div>Total Quotations (This Month)</div>
              <div>{quotationData?.quotation_card?.total_quotation}</div>
            </div>
            <div className="inventoryCard">
              <div>Converted to Sales</div>
              <div>{quotationData?.quotation_card?.converted_to_sale}</div>
            </div>

            <div className="inventoryCard">
              <div>Pending Quotations</div>
              <div>{quotationData?.quotation_card?.pending_quotation}</div>
            </div>
          </div>
          {/* filters  */}
          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
              <div>
                <div className="dropdownTitle">Filter by</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {filterToggler || "Select"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {/* status with submenu */}
                    <div className="submenu-container">
                      <Dropdown.Item className="has-submenu">
                        Status ▸
                      </Dropdown.Item>

                      <div className="submenu">
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("converted");
                          }}
                        >
                          Converted
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("pending");
                          }}
                        >
                          Pending
                        </Dropdown.Item>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <div className="dropdownTitle">Date Range</div>
                <Dropdown show={show} onToggle={() => setShow(!show)}>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {selectedLabel || "Select"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu customDateMenu">
                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("7");
                      }}
                    >
                      Last 7 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("15");
                      }}
                    >
                      Last 15 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("30");
                      }}
                    >
                      Last 30 days
                    </Dropdown.Item>

                    <Dropdown.Item disabled>Custom Date :</Dropdown.Item>

                    <Dropdown.Item
                      as="div"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => {
                          setShow(false); // close after selecting
                          setSelectedLabel(e.target.value);
                        }}
                      />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>

          {(searchQuery || filterToggler || selectedLabel) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of :
                </span>
                {searchQuery && (
                  <>
                    {" "}
                    &nbsp; <strong>Search:</strong> {searchQuery}{" "}
                  </>
                )}
                {filterToggler && (
                  <>
                    {" "}
                    &nbsp; <strong>Status:</strong> {filterToggler}{" "}
                  </>
                )}
                {selectedLabel && (
                  <>
                    {" "}
                    &nbsp; <strong>Date:</strong> {selectedLabel}{" "}
                  </>
                )}
              </div>
              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                {" "}
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}

          {/* table  */}
          <div className="titleOrderList">Recent Transactions</div>

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell align="left">Quotation ID</TableCell>
                    <TableCell align="left">Date</TableCell>
                    <TableCell align="left">Customer</TableCell>
                    <TableCell align="left">Phone</TableCell>
                    <TableCell align="left">Items</TableCell>
                    <TableCell align="left">Total Value (₹)</TableCell>

                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {quotationData?.results?.length > 0 ? (
                    quotationData?.results?.map((row) => (
                      <TableRow
                        key={row.QuotationId}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                        className="dashboardTableBody"
                      >
                        <TableCell align="left">{row.QuotationId}</TableCell>
                        <TableCell align="left">
                          {" "}
                          {new Date(row.date).toLocaleString("en-GB", {
                            timeZone: "UTC",
                          })}
                        </TableCell>
                        <TableCell align="left">{row.customer_name}</TableCell>
                        <TableCell align="left">{row.phone_number}</TableCell>
                        <TableCell align="left">
                          {row.items ? row.items : "--"}
                        </TableCell>
                        <TableCell align="left">{row.total_value}</TableCell>

                        <TableCell
                          align="left"
                          style={{
                            color: (() => {
                              switch (row.status) {
                                case "Pending":
                                  return "#F59E0B";
                                case "Converted":
                                  return "#10B981";
                                default:
                                  return "var(--color-font-secondary)";
                              }
                            })(),
                          }}
                        >
                          {row.status}
                        </TableCell>
                        <TableCell align="left">
                          <IoEyeOutline
                            onClick={() =>
                              navigate("/state-view-quotations", {
                                state: { Id: row.QuotationId },
                              })
                            }
                            style={{ cursor: "pointer" }}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align="center"
                        style={{ padding: "20px" }}
                      >
                        Data not available
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalCount}
              page={page}
              onPageChange={(event, newPage) => {
                setPage(newPage);
                sessionStorage.setItem("dis_quot_page", newPage);
              }}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]} //dropdown
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>
      </div>
    </>
  );
};
